"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerMonsterData = exports.registerAll = exports.get = exports.dataListSpawnable = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var onceOnly_sidecar_1 = require("../../../lib/onceOnly-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueMonstersAi_1 = require("./rogueMonstersAi");
var _default = {
    type: 'default',
    name: 'default',
    description: 'default',
    maxHp: 1,
    char: 'D',
    spawnChance: 1,
    isPlayer: false,
    sprite: rogueMonofont_sidecar_1.rogueMonofont.getSprite('?'),
    exp: 1,
    aiMode: rogueMonstersAi_1.EAiMode.AttackOnSight,
    detectChance: 0.5,
    color: rogueDef_sidecar_1.rogueDef.colors.light,
};
var dataType = 'monsters';
var dataList = [];
exports.dataListSpawnable = [];
var dataMapType = {};
var get = function (type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetData(dataType, dataMapType, type);
};
exports.get = get;
var registerAll = function () {
    onceOnly_sidecar_1.onceOnly.ensureCalledOnlyOnce(dataType);
    (0, exports.registerMonsterData)({
        type: '@',
        description: 'A rogue player',
        name: 'player',
        maxHp: 1,
        spawnChance: 0,
        isPlayer: true,
        sprite: sprites_sidecar_1.sprites.rogue10,
        aiMode: rogueMonstersAi_1.EAiMode.Player,
        color: rogueDef_sidecar_1.rogueDef.colors.yellow,
    });
    (0, exports.registerMonsterData)({
        type: 'r',
        description: 'A rat',
        name: 'rat',
        maxHp: 1,
        detectChance: 0.2,
        color: rogueDef_sidecar_1.rogueDef.colors.brown,
    });
    (0, exports.registerMonsterData)({
        type: 'R',
        description: 'A rat king',
        name: 'rat-king',
        maxHp: 3,
        spawnChance: 0.1,
        exp: 3,
        color: rogueDef_sidecar_1.rogueDef.colors.brown,
    });
    (0, exports.registerMonsterData)({
        type: 'g',
        description: 'A goblin',
        name: 'goblin',
        maxHp: 2,
        spawnChance: 0.75,
        exp: 2,
        color: rogueDef_sidecar_1.rogueDef.colors.green,
    });
};
exports.registerAll = registerAll;
var registerMonsterData = function (data) {
    assert_sidecar_1.assert.notNil(data.type);
    if (!data.char) {
        data.char = data.type;
    }
    if (!data.name) {
        data.name = '' + data.type;
    }
    if (!data.sprite) {
        data.sprite = rogueMonofont_sidecar_1.rogueMonofont.getSprite(data.char);
    }
    var merged = entitiesUtils_sidecar_1.entitiesUtils.genericRegisterData(dataType, data, _default, dataList, dataMapType);
    if (merged.spawnChance > 0) {
        exports.dataListSpawnable.push(merged);
    }
};
exports.registerMonsterData = registerMonsterData;
